module.exports = __webpack_public_path__ + "assets/img/continue.13679b2a.svg";